import flatten from 'lodash/flatten'
import isEmpty from 'lodash/isEmpty'
import {all, call, put, select, take, takeLatest, takeLeading} from 'redux-saga/effects'

import {LookbuilderViews} from '../../store/lookbuilder/enums'

import * as lookbuilderActions from '../../actions/lookbuilder'
import * as lookbuilderSelectors from '../../store/lookbuilder'
import * as track from '../../track/lookbuilder'
import * as userInteractionsActions from '../../actions/userInteractions'

/**
 * Handles navigation to the detail view
 */
export function* openDetailViewWorker() {
  yield put(lookbuilderActions.navigateToView(LookbuilderViews.detail))
}

export function* openDetailViewSaga() {
  yield takeLeading(lookbuilderActions.OPEN_LOOKBUILDER_DETAIL_VIEW, openDetailViewWorker)
}

/**
 * Handles the "Add To Look" button click action
 */
export function* addToLookbuilderLookWorker() {
  const currentProduct = yield select(lookbuilderSelectors.currentProduct)
  const currentCategory = yield select(lookbuilderSelectors.currentCategory)

  const incompatibleProducts = yield select(lookbuilderSelectors.getIncompatibleProducts)
  if (incompatibleProducts.length) {
    yield put(userInteractionsActions.openFunctionalRuleModal())
    yield take(lookbuilderActions.REMOVE_INCOMPATIBLE_PRODUCTS)
    yield all(
      flatten(
        incompatibleProducts.map(({category, incompatibleProduct}) => [
          put(lookbuilderActions.updatePlannerCategory(category, {})),
          call(
            track.removedProductFromLookbuilder,
            incompatibleProduct.name,
            category,
            'rules modal',
          ),
        ]),
      ),
    )
    yield put(userInteractionsActions.closeModal())
  }

  const plannerProduct = yield select(lookbuilderSelectors.getProductByCategory, currentCategory)
  yield call(
    track.addedProductToLookbuilder,
    currentProduct.name,
    currentCategory,
    !isEmpty(plannerProduct),
  )
  yield put(lookbuilderActions.updatePlannerCategory(currentCategory, currentProduct))
  yield put(lookbuilderActions.navigateToView(LookbuilderViews.planner))
}

export function* addToLookbuilderLookSaga() {
  yield takeLatest(lookbuilderActions.ADD_TO_LOOKBUILDER_LOOK, addToLookbuilderLookWorker)
}
